import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ReturnContext from '@/product/context/return/returnContext'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
} from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button, Menu, MenuItem } from '@mui/material'
import CartItem from './cartItem'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import PropTypes from 'prop-types'
import Loaders from '@/product/components/molecules/Loaders'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Layout from '@/product/components/templates/Layout'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const InvoiceView = (props) => {
    const returnContext = useContext(ReturnContext)
    const { single_invoice, getSingleInvoice, all_invoices } = returnContext
    let invoiceID = props.match?.params?.id ? props.match.params.id : 0
    let userId = props.match?.params?.uid ? props.match.params.uid : 0

    const [viewContent, setViewContent] = React.useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [print, setPrint] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    // temp lang Manager
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    useEffect(() => {
        resetFrom()
    }, [props])

    useEffect(() => {
        if (invoiceID && userId) {
            setIsLoading(true)
            formik.values.invoice_id = invoiceID
            formik.values.user_id = userId
            getSingleInvoice(formik.values)
        } else {
            resetFrom()
        }
    }, [invoiceID])
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceAddress: [],
        invoiceUser: [],
    })

    useEffect(() => {
        if (single_invoice) {
            console.log('singlee')
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceTransactions: single_invoice.transactionrecords,
            })
        } else {
            resetFrom()
        }
    }, [single_invoice])

    useEffect(() => {
        if (invoiceDetails.invoiceProducts.length) {
            setIsLoading(false)
        }
    }, [invoiceDetails])

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            invoiceAddress: [],
            invoiceUser: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceAddress: [],
                invoiceUser: [],
            })
        }
    }, [])
    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()
    const options = {}

    const generatePDF = (toPdf) => {
        setPrint(true)
        toPdf()
    }
    const completedPDF = () => {
        setPrint(false)
    }

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="">
                {' '}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <div className="buyerDetailsTab invoicesTab">
                        <div className="bdTop">
                            <div className="bdUser">
                                <h2>
                                    <span className="material-icons">
                                        account_circle
                                    </span>
                                    {invoiceDetails?.invoiceUser[0]?.first_name}{' '}
                                    {invoiceDetails?.invoiceUser[0]?.last_name}
                                </h2>
                            </div>
                            <div></div>
                        </div>
                        <AppBar position="static">
                            <Tabs
                                value={value}
                                aria-label="simple tabs example"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab
                                    label="Invoice Details"
                                    value={0}
                                    onClick={() => handleChange(0)}
                                />
                                <Tab
                                    label="Transaction Details"
                                    value={1}
                                    onClick={() => handleChange(1)}
                                />

                                <Tab
                                    label="Product Details"
                                    value={2}
                                    onClick={() => handleChange(2)}
                                />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <div className="invoiceInfoSection">
                                {' '}
                                <div className="invoiceDetailsTab">
                                    <h3>Invoice Details</h3>

                                    <h4>
                                        <span> Name: </span>
                                        {
                                            invoiceDetails?.invoiceUser[0]
                                                ?.first_name
                                        }{' '}
                                        {
                                            invoiceDetails?.invoiceUser[0]
                                                ?.last_name
                                        }
                                    </h4>
                                    <h4>
                                        <span>Email:</span>
                                        {invoiceDetails?.invoiceUser[0]?.email}
                                    </h4>
                                    <h4>
                                        <span> Phone:</span>
                                        {invoiceDetails?.invoiceUser[0]?.phone}
                                    </h4>
                                    <h4>
                                        <span>Return Invoice:</span>{' '}
                                        {
                                            invoiceDetails.cartValues
                                                .return_invoice
                                        }{' '}
                                    </h4>
                                    <h4>
                                        <span>Return Date:</span>{' '}
                                        {dateTimeFormatFunction(
                                            invoiceDetails.cartValues
                                                .cart_returndate
                                        )}{' '}
                                    </h4>
                                    <h4>
                                        <span>Status:</span>{' '}
                                        {invoiceDetails.cartValues.cart_returned
                                            ? 'Returned'
                                            : 'Pending'}
                                    </h4>
                                    {invoiceDetails.cartValues.reason ? (
                                        <h4>
                                            <span>Reason:</span>{' '}
                                            {capitalize(
                                                invoiceDetails.cartValues.reason
                                            )}
                                        </h4>
                                    ) : null}

                                    <h4>
                                        <span>Shipping Address:</span>
                                        <address>
                                            {
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.address1
                                            }
                                            <br />
                                            {
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.address2
                                            }
                                            <br />
                                            {invoiceDetails?.invoiceUser[0]
                                                ?.city &&
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.state &&
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.country && (
                                                    <>
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceUser[0]
                                                                ?.city
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceUser[0]
                                                                ?.state
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceUser[0]
                                                                ?.country
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceUser[0]
                                                                ?.zip
                                                        }
                                                    </>
                                                )}
                                        </address>
                                    </h4>
                                </div>
                                <div className="invoiceSummary">
                                    <h3>Invoice Summary</h3>
                                    <h4>
                                        <span> Items: </span>
                                        {invoiceDetails.invoiceProducts.length}
                                    </h4>

                                    {/* <h4>
                                    <span> Subtotal: </span>
                                    {currencyFormat(invoiceDetails.cartValues.per_total)}
                                </h4>
                                <h4>
                                    <span> VAT: </span>
                                    {invoiceDetails.invoiceProducts.length ? (
                                        <> ({invoiceDetails.invoiceProducts[0].tax_percent}% )</>
                                    ) : null}
                                </h4> */}

                                    <h4>
                                        <span> Total Amount: </span>
                                        <>
                                            {currencyFormat(
                                                invoiceDetails
                                                    .invoiceTransactions[0]
                                                    .amount
                                            )}
                                        </>
                                    </h4>
                                    {invoiceDetails.cartValues.total_deposit ? (
                                        <h4>
                                            <span> Bid Deposit: </span>
                                            <>
                                                -{' '}
                                                {currencyFormat(
                                                    invoiceDetails.cartValues
                                                        .total_deposit
                                                )}
                                            </>
                                        </h4>
                                    ) : null}

                                    {invoiceDetails.cartValues.total_paid ? (
                                        <h4>
                                            <span> Total Paid: </span>
                                            <>
                                                {currencyFormat(
                                                    invoiceDetails.cartValues
                                                        .total_paid
                                                )}
                                            </>
                                        </h4>
                                    ) : null}
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            {invoiceDetails.invoiceTransactions.length ? (
                                <>
                                    {/* <div className="row">{mapData(mapDataOptions)}</div> */}
                                    <div className="transDet d-flex justify-content-between flex-wrap">
                                        <>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        {/* <th scope="col">S.No</th> */}
                                                        <th scope="col">
                                                            Return ID
                                                        </th>
                                                        <th scope="col">
                                                            Return on
                                                        </th>
                                                        <th scope="col">
                                                            Method
                                                        </th>
                                                        <th scope="col">
                                                            Amount
                                                        </th>
                                                        <th scope="col">
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoiceDetails.invoiceTransactions.map(
                                                        (data, index) => (
                                                            <tr key={index}>
                                                                <td
                                                                    data-title={
                                                                        'Return ID'
                                                                    }
                                                                >
                                                                    {data.trans_id
                                                                        ? `# ${data.trans_id}`
                                                                        : '-'}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Return On'
                                                                    }
                                                                >
                                                                    {dateTimeFormatFunction(
                                                                        data.created_at
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Card'
                                                                    }
                                                                >
                                                                    {capitalize(
                                                                        data.refund_method
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Amount'
                                                                    }
                                                                >
                                                                    {currencyFormat(
                                                                        data.amount
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Payment Status'
                                                                    }
                                                                    style={{
                                                                        color:
                                                                            data.status ===
                                                                            'success'
                                                                                ? 'green'
                                                                                : 'red',
                                                                    }}
                                                                >
                                                                    {capitalize(
                                                                        data.status
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </>
                                    </div>
                                </>
                            ) : null}
                        </TabPanel>

                        <TabPanel value={value} index={2}>
                            <div className="table-responsive">
                                {invoiceDetails.invoiceProducts.length ? (
                                    <div className="cartProducts">
                                        <div>
                                            {invoiceDetails.invoiceProducts.map(
                                                (data, index) => (
                                                    <CartItem
                                                        data={data}
                                                        from="invoice"
                                                        amount={
                                                            invoiceDetails
                                                                .invoiceTransactions[0]
                                                                .amount
                                                        }
                                                    />
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </TabPanel>
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default InvoiceView
